import {DealCategory} from "@irati/types"

const blackListedTags = [
  // Production: Free Perks, Trending, Flexi Perks - DealCategory && DealTag
  "30c82ecd-fcd8-428b-a630-a2de25f79058",
  "eed484c8-ae0f-4e13-af92-64e37bcd3a41",
  "d8651ea3-7de8-42bb-9373-5236bfdef9fe",
  "3f5eb74d-517a-48f9-bd8e-f11a68c54c02",
  "6a367084-bdaf-49ee-9d01-83928a00f06f",
  // Staging: Flexi Perks, Free Perks
  "681a233b-2ad1-4084-9540-be86f6976e62",
  "0849dfd7-8709-421e-a950-a791a26cbc5d"
]

export const getDealMainCategory = (ids?: string[], dealCategories?: DealCategory[]) => {
  if (ids && ids.length > 0) {
    const mainCategories = ids?.map((tagId) => {
      const mainCategory = dealCategories?.find((deal: DealCategory) => deal.tags?.find((t) => t.uuid === tagId))

      if (blackListedTags.includes(mainCategory?.uuid!)) return null
      return mainCategory?.name || null
    })

    return mainCategories?.find((c) => c) || ""
  }
  return ""
}
